import FeedbackQuestionPage from '~/pages/communication/libs/FeedbackQuestionPage'
import {
  REPLAY_FEEDBACK,
  REPLAY_OPTIONS,
  REPLAY_QUESTION,
} from '~/pages/communication/replay/libs/components/ReplayCommunication/constants'
import { TPageProps } from '~/shared/types/commonTypes'

const OPTION_I18N_PREFIX = 'onboarding.communicationReplay.options'
const TITLE_I18N_KEY = 'onboarding.communicationReplay.title'

const ReplayCommunication = (props: TPageProps) => (
  <FeedbackQuestionPage
    {...props}
    question={REPLAY_QUESTION}
    titleI18nKey={TITLE_I18N_KEY}
    optionI18nKeyPrefix={OPTION_I18N_PREFIX}
    options={REPLAY_OPTIONS}
    feedback={REPLAY_FEEDBACK}
    contentGap={32}
  />
)

export default ReplayCommunication
